import React, { useState } from 'react';
import Layout from '../components/Layout';
import Hero from '../components/Hero';
import ContentRow from '../components/ContentRow';
import ContentCard from '../components/ContentCard';
import { PageHeader, Chips, Grid, EmptyState } from '../components/PageBits';
import { useCatalog } from '../context/CatalogContext';
import { Film } from 'lucide-react';

const GENRE_FILTERS = ['All', 'Action', 'Drama', 'Comedy', 'Thriller', 'Romance', 'Documentary', 'Sci-Fi', 'Kids', 'Independent', 'Historical'];

export default function Movies() {
  const [genre, setGenre] = useState('All');
  const { movies } = useCatalog();
  const byGenre = (g) => movies.filter((m) => m.genres.includes(g));
  const filtered = genre === 'All' ? movies : byGenre(genre);
  const sections = [
    { title: 'Popular Movies', items: [...movies].sort((a, b) => b.match - a.match).slice(0, 9) },
    { title: 'New Releases', items: movies.filter((m) => m.isNew || m.year === 2024) },
    { title: 'Action', items: byGenre('Action') },
    { title: 'Drama', items: byGenre('Drama') },
    { title: 'Comedy', items: byGenre('Comedy') },
    { title: 'Thriller', items: byGenre('Thriller') },
    { title: 'Documentaries', items: byGenre('Documentary') },
    { title: 'African Cinema', items: movies.filter((m) => /Yoruba|Pidgin|Swahili|Zulu|Hausa|Wolof|Twi/.test(m.language)) },
    { title: 'Independent Films', items: [...byGenre('Independent'), ...byGenre('Lifestyle')] },
  ];
  return (
    <Layout>
      <PageHeader title="Movies" subtitle="Blockbusters, independents and African cinema." />
      <Chips options={GENRE_FILTERS} value={genre} onChange={setGenre} className="px-[22px] mb-4" testId="movie-genres" />
      {genre === 'All' ? (
        <>
          <div className="px-[22px]"><div className="rounded-xl overflow-hidden"><Hero compact slides={[{ contentId: 'neon-horizon' }, { contentId: 'the-last-voyage' }, { contentId: 'sunset-kingdom' }]} /></div></div>
          {sections.map((s) => <ContentRow key={s.title} title={s.title} items={s.items} testId={`movies-row-${s.title.toLowerCase().replace(/\s+/g, '-')}`} />)}
          <div className="h-10" />
        </>
      ) : (
        <div className="pb-10">
          <div className="px-[22px] mb-3 text-[13px] text-[#C7C4CB]">{filtered.length} {genre} title{filtered.length !== 1 ? 's' : ''}</div>
          {filtered.length ? <Grid>{filtered.map((m) => <ContentCard key={m.id} item={m} className="!w-full" />)}</Grid> : <EmptyState icon={Film} title="No movies in this genre yet" />}
        </div>
      )}
    </Layout>
  );
}
